import { render, staticRenderFns } from "./BankEmailForm.vue?vue&type=template&id=3846dbce&scoped=true&"
import script from "./BankEmailForm.vue?vue&type=script&lang=js&"
export * from "./BankEmailForm.vue?vue&type=script&lang=js&"
import style0 from "./BankEmailForm.vue?vue&type=style&index=0&id=3846dbce&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3846dbce",
  null
  
)

export default component.exports